import { Routes, Route, Navigate } from "react-router";
import {
    AiTools,
    ContactUs,
    EducationHub,
    Home,
    NotFound,
    PracticeInformation,
    ProfessionalInformation,
    Profile,
    TermsAndConditions,
    VendorDetails
} from '../pages';
import ProtectedRoutes from "./ProtectedRoutes";

function AppRoutes() {
    return (
        <Routes>
            <Route path="/" element={<ProtectedRoutes><div /></ProtectedRoutes>} />
            <Route path="/terms-of-use" element={<TermsAndConditions />} />
            <Route path="/professional-information" element={<ProfessionalInformation />} />
            <Route path="/practice-information" element={<PracticeInformation />} />
            <Route path="/home" element={<Home />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/vendor-details" element={<VendorDetails />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/not-found" element={<NotFound />} />
            <Route path="/education-hub" element={<EducationHub />} />
            <Route path="/ai-tools" element={<AiTools />} />
            <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
    );
}

export default AppRoutes;